import React from "react";
import styled from "styled-components";
import Container from "../../Components/Container";
import Row from "../../Components/Row";
import Collapsible from "../../Components/Collapsible";

const Title = styled.h1`
  font-weight: 700;
  font-size: 40px;
  color: #fff;
`;

const Border = styled.div`
  height: 1px;
  width: 100%;
  background-color: #fff;
`;

const cardData = [
  {
    title: "Posso testar antes de pagar?",
    subtitle:
      "Sim! Você pode começar com um período gratuito para testar o Alfred no seu WhatsApp e ver os resultados na prática.!",
  },
  {
    title: "Preciso saber programar?",
    subtitle:
      "De jeito nenhum. O Alfred é plug & play: em poucos cliques você conecta seu número e já começa a atender clientes.",
  },
  {
    title: "O Alfred substitui atendentes humanos?",
    subtitle:
      "Não. Ele cuida do atendimento repetitivo e inicial, mas você pode assumir a conversa a qualquer momento. O Alfred é parceiro da sua equipe, não substituto.",
  },
  {
    title: "E se o cliente fizer uma pergunta que ele não sabe responder?",
    subtitle:
      "Nesses casos, o Alfred pede ajuda: ele transfere a conversa para você ou sua equipe, garantindo que ninguém fique sem resposta.",
  },
  {
    title: "O Alfred é seguro?",
    subtitle:
      "O Alfred utiliza tecnologia de ponta para garantir a segurança dos dados dos usuários. Todas as informações são criptografadas e armazenadas de forma segura, seguindo as melhores práticas de segurança da informação.",
  },
  {
    title: "Funciona apenas no WhatsApp?",
    subtitle:
      "O Alfred foi desenvolvido para funcionar no WhatsApp, mas estamos trabalhando para expandir para outras plataformas no futuro.",
  },
  {
    title: "O Alfred pode ser integrado com outros sistemas?",
    subtitle:
      "Sim, o Alfred pode ser integrado com outros sistemas através de APIs, permitindo uma maior flexibilidade e personalização.",
  },
];

const Answers = () => {
  return (
    <Container
      style={{
        marginTop: "40px",
        textAlign: "center",
      }}
      id="section-6"
    >
      <Title>
        <span style={{ color: "#E4DA1B" }}>Perguntas</span> Frequentes
      </Title>
      <Row
        xs="1fr"
        sm="1fr"
        md="1fr"
        lg="1fr"
        xl="1fr"
        style={{ marginTop: "60px",}}
      >
        <div>
          {cardData.map((cardItem, index) => (
            <div key={index} style={{color:"#fff"}}>
              <Collapsible title={cardItem.title} content={cardItem.subtitle}  />
              {index + 1 < cardData.length && <Border />}
            </div>
          ))}
        </div>
      </Row>
    </Container>
  );
};

export default Answers;
